module.exports = __webpack_public_path__ + "img/awesome-img.8e332c01.png";